import { Col, Row } from "antd";
import React, { useEffect, useRef, useState } from "react";
import {
    DropDown,
    SubmitButton,
    TextComponent
} from "../../../../components";
import DragableComp from "../../../../components/DragableComp/DragableComp";
import styles from "./customTemplate.module.css";

import { HiOutlineMinusSmall, HiOutlinePlusSmall } from "react-icons/hi2";
import img3 from "../../../../assets/staticImages/templateImg.png";
import useWindowDimensions from "../../../../hooks/useWindowDimensions";
import { useNavigate } from "react-router-dom";

function CustomizeTemplate() {
    const containerRef = useRef(null);
    const [TextsList, setTextsList] = useState([
        {
            text: "text1",
            style: {
                fontSize: 20,
                fontWeight: "bold",
                zIndex: 4,
            },
            row: 1,
            col: 1
        },
    ]);
    const [slectedIndex, setslectedIndex] = useState();
    const navigate = useNavigate()

    const ChangeStyle = (value) => {
        let cpylist = [...TextsList];
        cpylist.splice(slectedIndex, 1, {
            ...TextsList[slectedIndex],
            style: {
                ...TextsList[slectedIndex].style,
                ...value,
            },
        });
        setTextsList(cpylist);
    };

    const ChangeText = (value) => {
        let cpylist = [...TextsList];
        cpylist.splice(slectedIndex, 1, {
            ...TextsList[slectedIndex],
            text: value
        });
        setTextsList(cpylist);
    };
    return (
        <Row className={styles.mainCont}>
            {/* <Col className={styles.leftCont}>
                <Box boxClass={styles.sideBox}>
                    <AntdTab items={tabs} centered={true} titleClass={styles.tabTitle} />
                </Box>
            </Col> */}
            <Col className={styles.rightContent}>
                <Row className={styles.contHead}>
                    <Col className={styles.dropdownCont}>
                        <DropDown placeholder={"Fonts Family"}
                            name={'role'}
                            // onChange={handleChangeVendorType}
                            stylesClass={styles.fontDropdown}
                            contClass={styles.contClass}
                            options={[
                                { value: 'font2', option: 'font1' },
                                { value: 'font3', option: 'font2' },
                                { value: 'font4', option: 'font3' }
                            ]} />
                    </Col>
                    <div className={styles.line} />
                    <Col className={styles.formatCont}>
                        <HiOutlineMinusSmall
                            size={30}
                            color={'white'}
                            cursor="pointer"
                            onClick={() => {
                                ChangeStyle({
                                    fontSize: TextsList[slectedIndex].style.fontSize - 1,
                                });
                            }}
                        />
                        <TextComponent
                            text={TextsList[slectedIndex]?.style?.fontSize}
                            textClass={styles.sizeText}
                        />
                        <HiOutlinePlusSmall
                            size={30}
                            color={'white'}
                            cursor="pointer"
                            onClick={() => {
                                ChangeStyle({
                                    fontSize: TextsList[slectedIndex].style.fontSize + 1,
                                });
                            }}
                        />
                    </Col>
                    <Col className={styles.formatCont}>
                        <text
                            style={{ textDecoration: "underline red" }}
                            onClick={() => {
                                ChangeStyle({
                                    textDecoration: "underline red",
                                });
                            }}
                        >
                            A
                        </text>
                        <text
                            style={{ fontWeight: "bold" }}
                            onClick={() => {
                                ChangeStyle({
                                    fontWeight: "bold",
                                });
                            }}
                        >
                            B
                        </text>
                        <text
                            style={{ fontStyle: "italic", fontFamily: "initial" }}
                            onClick={() => {
                                ChangeStyle({
                                    fontStyle: "italic",
                                    fontFamily: "initial",
                                });
                            }}
                        >
                            I
                        </text>
                        <text
                            style={{ textDecoration: "underline" }}
                            onClick={() => {
                                ChangeStyle({
                                    textDecoration: "underline",
                                });
                            }}
                        >
                            U
                        </text>
                    </Col>
                </Row>
                <Row>
                    <div
                        ref={containerRef}
                        className={styles.container}
                        style={{ backgroundImage: `url(${img3})` }}
                    >
                        {TextsList.map((data, i) => (
                            <RenderDragableList
                                containerRef={containerRef}
                                data={data}
                                setslectedIndex={setslectedIndex}
                                slectedIndex={slectedIndex}
                                i={i}
                                ChangeText={ChangeText}
                            />
                        ))}
                    </div>
                </Row>
                <Row className={styles.btnCont}>
                    <SubmitButton title="Save Edits" btnClass={styles.saveBtn}
                        onClick={() => navigate('/events/SelectedTemplate', { state: { headrTitle: 'RSVP', screenFrom: 'Template' } })}
                    />
                </Row>
            </Col>
        </Row>
    );
}

const RenderDragableList = ({
    data,
    containerRef,
    setslectedIndex,
    slectedIndex,
    i,
    ChangeText
}) => {
    const textRef = useRef(null);
    const divRef = useRef(null);

    const [rows, setRows] = useState(1)
    const [cols, setCols] = useState(5)

    const { width, height } = useWindowDimensions()

    const handleOutsideClick = (e) => {
        if (divRef.current && !divRef.current.contains(e.target) && containerRef.current.contains(e.target)) {
            setslectedIndex(null);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);

    return (
        <DragableComp containerRef={containerRef} initialX={width < 578 ? 70 : width < 921 ? 120 : width < 1025 ? 160 : width < 1281 ? 250 : 350} initialY={width < 578 ? 70 : width < 921 ? 120 : width < 1025 ? 160 : width < 1281 ? 250 : 350}>
            <div ref={divRef} className={styles.growWrap}>
                <textarea
                    value={data.text}
                    ref={textRef}
                    onChange={(e) => ChangeText(e.target.value)}
                    className={`${styles.contHeading} ${slectedIndex == i && styles.selectText}`}
                    onClick={() => setslectedIndex(i)}
                    style={data.style}
                />
                {/* <TextComponent
                    ref={textRef}
                    text={data.text}
                    textClass={`${styles.contHeading} ${slectedIndex == i && styles.selectText
                        }`}
                    style={data.style}
                    onClick={() => setslectedIndex(i)}
                /> */}
            </div>
        </DragableComp>
    );
};

export default CustomizeTemplate;
